import type { ContextData } from './builders/types';

/**
 * Transforms a leoContext array into the user_context shape expected by
 * the backend (llm.prompt, llm.arguments, type) and the frontend conversation
 * pill (displayName).
 *
 * The "leaf" context is the last non-ambient item in the array — this is the
 * primary subject of the conversation (e.g., a metric, chart, or detected issue).
 * Ambient contexts (view, filters) contribute to the prompt but are not the leaf.
 */
export function buildUserContext (data: ContextData<string, Record<string, unknown>>[], suggestedQuestions: string[]) {
    const prompt = data
        .map((ctx) => ctx.description)
        .filter(Boolean)
        .join('\n');

    const leafContext = [...data]
        .reverse()
        .find((ctx) => !ctx.ambient);

    return {
        displayName: leafContext?.displayName ?? '',
        type: leafContext?.type ?? '',
        leoContext: data,
        suggestedQuestions,
        llm: {
            prompt,
            arguments: leafContext?.args ?? {},
        },
    };
}
